module.exports = __webpack_public_path__ + "static/media/icon_98.92c6b8a3.svg";